import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import withWidth from '@material-ui/core/withWidth';
import queryString from 'query-string';
import cx from 'classnames';
import { I18n } from 'react-redux-i18n';

// Components.
import BackgroundGrid from 'components/BackgroundGrid';

// Components.
import Header from 'components/Header';
import Footer from 'components/Footer';
import IntercomChat from 'components/IntercomChat';
import LoaderSpinnerPage from 'components/LoaderSpinnerPage';

import UserProfileFooterMenu from 'components/UserProfileFooterMenu';

// Actions.
import * as AuthActions from 'actions/AuthActions';
import * as ConfigActions from 'actions/ConfigActions';
import * as PayProducts from 'actions/PayProductsActions';
import * as PayConnectedPackagesActions from 'actions/PayConnectedPackagesActions';

// Utils.
import { isWebviewApp, isMobile } from 'utils';

// Styles.
import styles from './styles.module.scss';

// Images.
import { ReactComponent as WarningIcon } from './images/warningIcon.svg';

import { baseURL } from 'config/index'

@withWidth()
@withRouter
@connect(
  state => ({
    auth: state.auth,
    profile: state.profile,
    config: state.config,
    i18n: state.i18n,
    payProducts: state.payProducts,
    payConnectedPackages: state.payConnectedPackages,
    consents: state.consents,
  }),
  dispatch => ({
    authActions: bindActionCreators(AuthActions, dispatch),
    configActions: bindActionCreators(ConfigActions, dispatch),
    payProductsActions: bindActionCreators(PayProducts, dispatch),
    payConnectedPackagesActions: bindActionCreators(PayConnectedPackagesActions, dispatch),
  })
)
export default class AuthContainer extends Component {

  static contextTypes = {
    router: PropTypes.object,
  };

  static propTypes = {
    auth: PropTypes.object.isRequired,
    profile: PropTypes.object.isRequired,
    consents: PropTypes.object.isRequired,
    config: PropTypes.object.isRequired,
    i18n: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    configActions: PropTypes.object.isRequired,
    additionTitle: PropTypes.element,
    content: PropTypes.element,
    children: PropTypes.element,
  };

  componentWillMount() {
    if (this.props.location) {
      const query = queryString.parse(this.props.location.search);
      if (query.token !== undefined) {
        this.props.authActions.loginToken(query.token);
      }
      if (query.scope !== undefined && query.scope === 'ifttt') {
        const search = queryString.stringify(query);
        window.location.replace(`${baseURL}/oauth2/authorize/?${search}`);
      }
    }
  }

  render() {
    const {
      auth,
      profile: { isFetched: isFetchedProfile, isUpdated: isUpdatedProfile, profile },
      consents: { isFetched: isFetchedConsents, consents },
      config: { isFetched: isFetchedConfig, config },
      location,
      secondaryMenu,
      content,
      children,
      payConnectedPackages,
      width,
    } = this.props;
    if (auth.isAuthenticated) {
      if (!isUpdatedProfile && !isFetchedProfile) {
        return <LoaderSpinnerPage />;
      }
    }

    const isWebviewAppStatus = isWebviewApp();

    return (
      <div className={cx(styles.authWrapper, { [styles.isWebView]: isWebviewAppStatus })} style={{ width: width }}>
        <Header
          isFetchedProfile={isFetchedProfile}
          auth={auth}
          profile={profile}
          locationPath={location.pathname}
          payConnectedPackages={payConnectedPackages}
           width={width}
        />
        <div id="content" className={styles.content}>
          <div className={cx("container-fixed", styles.contentContainer)} style={{ width: width }}>
            {(isFetchedProfile && profile.billing_status === 'failed') &&
              <div className={styles.paymentMessageOldProduct}>
                <WarningIcon />
                {I18n.t('Failed payment Please double-check your payment info')}
              </div>
            }
            <Grid container>
              <Grid container className={cx(styles.contentWrapper, { [styles.isWebView]: isWebviewAppStatus })}>
                <BackgroundGrid />
                {!secondaryMenu &&
                  <Grid item xs={12} md={12} style={{zIndex: 100}}>
                    
                    {content || children}
                    
                  </Grid>
                }
                
                {secondaryMenu &&
                  <React.Fragment>
                    <Hidden xsDown smDown>
                      <Grid item zeroMinWidth={true} md={3}>
                        {secondaryMenu}
                      </Grid>
                    </Hidden>
                    <Hidden xsDown smDown>
                      <Grid item zeroMinWidth={true} md={1} />
                    </Hidden>
                    <Grid item xs={12} md={8}>
                      {content || children}
                    </Grid>
                  </React.Fragment>
                }
                <UserProfileFooterMenu locationPath={location.pathname} />
              </Grid>
            </Grid>
          </div>
        </div>
        <Footer locationPath={location.pathname} />
        <IntercomChat
          auth={auth}
          isFetchedProfile={isFetchedProfile}
          isFetchedConsents={isFetchedConsents}
          profile={profile}
          consents={consents}
          isFetchedConfig={isFetchedConfig}
          config={config}
          locationPath={location.pathname}
        />
      </div>
    );
  }

}
